import styled from '@emotion/styled';
import { COLORS3, FONT, MEDIA_QUERY, SPACING } from '@zola/zola-ui/src/styles/emotion';
import H from '@zola/zola-ui/src/typography/Headings';
import T from '@zola/zola-ui/src/typography/Text';

export const TextBlockSection = styled.section`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: ${SPACING.S32} ${SPACING.S24};

  ${MEDIA_QUERY.TABLET} {
    padding: 56px;
  }
  ${MEDIA_QUERY.DESKTOP} {
    padding: 56px 0;
  }
  ${MEDIA_QUERY.DESKTOP_MASSIVE} {
    padding: 56px 8px;
  }
`;

export const Accent = styled(T.Accent)`
  font-weight: ${FONT.FONT_WEIGHT_MEDIUM};
`;

export const TextBlockSectionTitle = styled(H.Title2)`
  ${MEDIA_QUERY.NOT_MOBILE} {
    text-align: center;
    ${FONT.textSizeUltraCompact(FONT.FONT_SIZE_LARGER)}
  }
  ${MEDIA_QUERY.DESKTOP} {
    ${FONT.textSizeUltraCompact(FONT.FONT_SIZE_SEMI_HUGE)}
  }
`;

export const TextBlockDek = styled.div`
  ${FONT.textSizeRegular(FONT.FONT_SIZE_SMALL)}
  ${MEDIA_QUERY.NOT_MOBILE} {
    text-align: center;
    ${FONT.textSizeRegular(FONT.FONT_SIZE_REGULAR)}
  }
  margin-top: ${SPACING.S24};
`;

export const TextBlocksContainer = styled.div`
  display: flex;
  margin-top: ${SPACING.S32};
  ${MEDIA_QUERY.EXCLUDE_DESKTOP} {
    flex-direction: column;
    margin-top: ${SPACING.S24};
  }
`;

export const TextBlockContainer = styled.div`
  flex: 1;
  padding: ${SPACING.S24} 0;
  ${MEDIA_QUERY.TABLET} {
    padding: ${SPACING.LG} 0;
  }
  ${MEDIA_QUERY.EXCLUDE_DESKTOP} {
    :first-of-type {
      padding-top: 0;
    }
    :last-child {
      padding-bottom: 0;
    }
    :not(:last-child) {
      border-bottom: 1px solid ${COLORS3.BLACK_030};
    }
  }
  ${MEDIA_QUERY.DESKTOP} {
    padding: ${SPACING.S24} 56px;
    :not(:last-child) {
      border-right: 1px solid ${COLORS3.BLACK_030};
    }
  }
`;

export const TextBlockTitle = styled(H.TitleAccent3)`
  ${FONT.textSizeRegular(FONT.FONT_SIZE_LARGER)}
`;

export const TextBlockText = styled.div<{ color?: string }>`
  ${FONT.textSizeRegular(FONT.FONT_SIZE_SMALL)}
  ${MEDIA_QUERY.NOT_MOBILE} {
    ${FONT.textSizeRegular(FONT.FONT_SIZE_REGULAR)}
  }
  ${p => p.color && `color: ${p.color};`}
`;

export const TextBlockCTAsContainer = styled.div`
  display: flex;
  align-items: center;
  margin-top: ${SPACING.S24};
  gap: ${SPACING.S8};
`;
